<!--=============================
=            PRICING            =
==============================-->
<template>
    <div>
        <v-row>
            <base-header>
                <div slot="page-header"> Pricing</div>
            </base-header>
        </v-row>
        <v-row class="mb-15">
            <template>

                <v-col cols="12" md="12" sm="12">
                    <base-card>
                        <div slot="card-header">Table Pricing

                        </div>
                        <div slot="card-subheader">Et elit sit non reprehenderit id laboris dolor dolor officia officia
                            cillum elit excepteur..</div>
                        <div slot="card-body">
                            <v-row justify="space-between">
                                <v-col col="12" sm="3" md="3">
                                    <v-hover v-slot="{ hover }" open-delay="200">
                                        <v-card class="rounded-lg justify-center mx-auto" :elevation="hover ? 16 : 2"
                                                :class="{ 'on-hover': hover }"
                                                :color="$vuetify.theme.dark ? 'theme-dark' : 'theme-light'" tile
                                                outlined>
                                            <v-img height="100" src="../../assets/images/theme.jpg">
                                                <div
                                                     class="d-flex text-5 white--text  font-weight-bold pt-10 justify-center mx-auto mb-6">
                                                    DEVELOPER


                                                </div>
                                            </v-img>


                                            <v-list color="transparent" class="text-center " nav dense>
                                                <v-list-item-title class="text-h6 font-weight-bold">
                                                    $9 /month
                                                </v-list-item-title>
                                                <v-list-item>
                                                    For Bussiness the want optimize web quieries
                                                </v-list-item>
                                                <v-list-item-group v-model="selectedItem" color="primary">
                                                    <v-list-item v-for="(item, i) in items" :key="i">

                                                        <v-list-item-content>
                                                            <v-list-item-title v-text="item.text"></v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list-item-group>
                                            </v-list>
                                            <div class="text-center ma-3">
                                                <v-btn color="primary" dark>
                                                    Choose Plan
                                                </v-btn>
                                            </div>
                                        </v-card>
                                    </v-hover>
                                </v-col>
                                <v-col col="12" sm="3" md="3">
                                    <v-hover v-slot="{ hover }" open-delay="200">
                                        <v-card class="rounded-lg justify-center mx-auto" :elevation="hover ? 16 : 2"
                                                :class="{ 'on-hover': hover }"
                                                :color="$vuetify.theme.dark ? 'theme-dark' : 'theme-light'" tile
                                                outlined>
                                            <v-img height="100" src="../../assets/images/theme.jpg">
                                                <div
                                                     class="d-flex text-5 white--text font-weight-bold pt-10 justify-center mx-auto mb-6">
                                                    START


                                                </div>
                                            </v-img>


                                            <v-list color="transparent" class="text-center" nav dense>
                                                <v-list-item-title class="text-h6 font-weight-bold">
                                                    $20 /month
                                                </v-list-item-title>
                                                <v-list-item>
                                                    For Bussiness the want optimize web quieries
                                                </v-list-item>
                                                <v-list-item-group v-model="selectedItem" color="primary">
                                                    <v-list-item v-for="(item, i) in items" :key="i">

                                                        <v-list-item-content>
                                                            <v-list-item-title v-text="item.text"></v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list-item-group>
                                            </v-list>
                                            <div class="text-center ma-3">
                                                <v-btn color="primary" dark>
                                                    Choose Plan
                                                </v-btn>
                                            </div>
                                        </v-card>
                                    </v-hover>
                                </v-col>

                                <v-col col="12" sm="3" md="3">
                                    <v-hover v-slot="{ hover }" open-delay="200">
                                        <v-card class="rounded-lg justify-center mx-auto" :elevation="hover ? 16 : 2"
                                                :class="{ 'on-hover': hover }"
                                                :color="$vuetify.theme.dark ? 'theme-dark' : 'theme-light'" tile
                                                outlined>
                                            <v-img height="100" src="../../assets/images/theme.jpg">
                                                <div
                                                     class="d-flex text-5 white--text  font-weight-bold pt-10 justify-center mx-auto mb-6">
                                                    ENTERPRISE

                                                </div>
                                            </v-img>


                                            <v-list color="transparent" class="text-center" nav dense>
                                                <v-list-item-title class="text-h6 font-weight-bold">
                                                    $50 /month
                                                </v-list-item-title>
                                                <v-list-item>
                                                    For Bussiness the want optimize web quieries
                                                </v-list-item>
                                                <v-list-item-group v-model="selectedItem" color="primary">
                                                    <v-list-item v-for="(item, i) in items" :key="i">

                                                        <v-list-item-content>
                                                            <v-list-item-title v-text="item.text"></v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list-item-group>
                                            </v-list>
                                            <div class="text-center ma-3">
                                                <v-btn color="primary" dark>
                                                    Choose Plan
                                                </v-btn>
                                            </div>
                                        </v-card>
                                    </v-hover>
                                </v-col>

                                <v-col col="12" sm="3" md="3">
                                    <v-hover v-slot="{ hover }" open-delay="200">
                                        <v-card class="rounded-lg justify-center mx-auto" :elevation="hover ? 16 : 2"
                                                :class="{ 'on-hover': hover }"
                                                :color="$vuetify.theme.dark ? 'theme-dark' : 'theme-light'" tile
                                                outlined>
                                            <v-img height="100" src="../../assets/images/theme.jpg">
                                                <div
                                                     class="d-flex text-5 white--text  font-weight-bold pt-10 justify-center mx-auto mb-6">
                                                    BUSINESS


                                                </div>
                                            </v-img>


                                            <v-list color="transparent" class="text-center card-light" nav dense>
                                                <v-list-item-title class="text-h6 font-weight-bold">
                                                    $120 /month
                                                </v-list-item-title>
                                                <v-list-item>
                                                    For Bussiness the want optimize web quieries
                                                </v-list-item>
                                                <v-list-item-group v-model="selectedItem" color="primary">
                                                    <v-list-item v-for="(item, i) in items" :key="i">

                                                        <v-list-item-content>
                                                            <v-list-item-title v-text="item.text"></v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list-item-group>
                                            </v-list>
                                            <div class="text-center ma-3">
                                                <v-btn color="primary" dark>
                                                    Choose Plan
                                                </v-btn>
                                            </div>
                                        </v-card>
                                    </v-hover>
                                </v-col>

                            </v-row>
                        </div>
                    </base-card>
                </v-col>



            </template>
        </v-row>
        <v-row style="height:100px;"></v-row>

    </div>

</template>
<script>
    import BaseCard from "../../components/Base/BaseCard.vue";
    import BaseHeader from '../../components/Base/BaseHeader'
    export default {
        components: {
            BaseCard,
            BaseHeader
        },
        data: () => ({
            items2: [{
                    icon: 'mdi-wifi',
                    text: 'Wifi',
                },
                {
                    icon: 'mdi-bluetooth',
                    text: 'Bluetooth',
                },
                {
                    icon: 'mdi-chart-donut',
                    text: 'Data Usage',
                },
            ],
            model: 1,
            selectedItem: 0,
            items: [{
                    text: 'All limits liks',
                    icon: 'done'
                },
                {
                    text: 'Shared with me',
                    icon: 'done'
                },
                {
                    text: 'Starred',
                    icon: 'done'
                },
                {
                    text: 'Recent',
                    icon: 'done'
                },
                {
                    text: 'Offline',
                    icon: 'done'
                },

            ],
        }),

    }
</script>
<style scoped>
    .card-light {
        border-radius: 1em;
        border: 1px solid rgba(255, 255, 255, 0.5);
        text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
        background: rgba(255, 255, 255, 0.2);
        -webkit-backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
        transform: perspective(500px);
        transform-style: preserve-3d;
    }
</style>


<!--====  End of PRICING  ====-->